import React from 'react';
import { H5, P1, TextLink, P2 } from 'pfm-ui-components';
import { convertToCamelCase, addSpaceAfterComma, removeExtraSpace } from '../../../utils/common';
import styled from 'styled-components';
import ChevronRightBlack from '../../../assets/icons/down-red-arrow.svg';
import { up } from 'styled-breakpoints';

const twoFactorAuthenticationInfoInvest = (twoFAResponseData, folioNumber, showMore, setShowMore, mode_of_oper_ac) => {

  return (<>
    {showMore ? <React.Fragment>
      <StyledP2>
        Dear Customer, as per the latest SEBI guidelines on enhancing security of MF transactions a new two-factor Authentication (2FA) process has come into effect from 1st April' 23. At the time of executing a transaction, an OTP is sent to your mobile no & email id registered with the Bank, however as per the circular, if there is a mismatch between the mobile number & email id registered with the Bank and that with the Asset Management Company (AMC), such transactions will get rejected.
      </StyledP2>
      <br />
      <StyledP3>
        Mobile Number registered in Folio at: {convertToCamelCase(removeExtraSpace(twoFAResponseData.amcName))}: {addSpaceAfterComma(twoFAResponseData.rtaMobile)}
      </StyledP3>
      <StyledP3>
        Mobile number registered in Axis Bank: {addSpaceAfterComma(twoFAResponseData.dbMobile)}
      </StyledP3>
      <br />
      <StyledP3>
        Email ID registered in Folio at: {convertToCamelCase(removeExtraSpace(twoFAResponseData.amcName))}: {addSpaceAfterComma(twoFAResponseData.rtaEmail)}
      </StyledP3>
      <StyledP3>
        Email ID registered in Axis Bank: {addSpaceAfterComma(twoFAResponseData.dbRegEmail1)}
      </StyledP3>
      <br />
      {mode_of_oper_ac ? (<><StyledP2>
        Request you either initiate a transaction in New Folio or visit the site of
        {convertToCamelCase(removeExtraSpace(twoFAResponseData.amcName))}
        to update your details in order to continue investing in existing folio
      </StyledP2>
        <br />
      </>)
        : (<><StyledP2>
          Request you to visit the site of
          {convertToCamelCase(removeExtraSpace(twoFAResponseData.amcName))}
          to update your details in order to continue investing in existing folio
        </StyledP2>
          <br />
        </>)
      }
      <StyledP2>
        Axis Bank shall not be liable or responsible for any loss or shortfall resulting from the rejection of these transaction/s.
        </StyledP2>
        <StyledP2>
        <TermsAndConditionText onClick={() => setShowMore(false)}>{" Read Less"}
          <ChevronWrapper1>
            <ChevronRightBlackStyled></ChevronRightBlackStyled>
          </ChevronWrapper1>
        </TermsAndConditionText>
        </StyledP2>
    </React.Fragment> :
      <>

        <React.Fragment>
          <StyledP2>
            Dear Customer, we have observed you have selected folio {folioNumber} however, there is a mismatch in the contact details registered with the bank and with the
            {convertToCamelCase(removeExtraSpace(twoFAResponseData.amcName))}.
            As per SEBI circular in such cases transactions will get rejected.
          </StyledP2>
          <StyledP2>
            So request you to click on "Continue With New Folio" to transact in New Folio or update your contact details with {convertToCamelCase(removeExtraSpace(twoFAResponseData.amcName))} to continue transaction in existing folio.
          </StyledP2>
          <StyledP2>
            For More Details,
            <TermsAndConditionText
              onClick={() => setShowMore(true)}
            >
              {"  Read More"}
              <ChevronWrapper>
                <ChevronRightBlack></ChevronRightBlack>
              </ChevronWrapper>
            </TermsAndConditionText>
          </StyledP2>
        </React.Fragment>
      </>}
  </>
  );
};

const TermsAndConditionText = styled.span`
  color: ${(props) => props.theme.palette.burgundy1};
  padding: 0;
  margin: 0;
  margin-block-end: 0;
  margin-block-start: 0;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const StyledP1 = styled(P1)`
  color: ${(props) => props.theme.palette.grey2};
  align-self: center;
  padding: 4px;
`;

const StyledP2 = styled(P2)`
  color: ${(props) => props.theme.palette.grey2};
  align-self: center;
  padding: 4px;
`;

const StyledP3 = styled(P2)`
  color: ${(props) => props.theme.palette.grey2};
  align-self: center;
  padding: 4px;
  font-weight: bold;
`;

const ChevronWrapper = styled.div`
  margin-left: 150px;
  margin-top: -20px;
  ${up('md')} {
    margin-left: 175px;
    margin-top: -20px;
  }
`;

const ChevronWrapper1 = styled.div`
margin-left: 50px;
margin-top: -22px;
${up('md')} {
  margin-left: 60px;
  margin-top: -23px;
}
`;

const ChevronRightBlackStyled = styled(ChevronRightBlack) <{ faq?: boolean; isOpen: boolean; enable: boolean }>`
  transition-duration: 0.8s;
  transform: ${(props) => (props.$isOpen ? 'rotate(-180deg)' : 'rotate(180deg)')};
  margin-top: 2px;
`;
export default twoFactorAuthenticationInfoInvest;